import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Alert,
  Box,
  Dialog,
  DialogTitle,
  IconButton,
  InputAdornment,
  Portal,
  Snackbar,
  TextField,
  Typography,
} from "@mui/material";
import { useEffect, useRef, useState } from "react";
import PropTypes from "prop-types";

import { useUserData } from "src/context/userContext";
import { sendTilaustiedot_exported } from "src/data/keikka/handleKeikka";
import mailClass from "src/data/system/mailClass";

import StepButtons from "src/components/buttons/StepButtons/StepButtons";
import HelperIcon from "src/components/icons/purposed/HelperIcon/HelperIcon";
import MyDivider from "src/components/layout/MyDivider";
import ExpandCollapseIcon from "src/components/icons/purposed/ExpandCollapseIcon";
import { CloseIcon } from "src/components/icons/ActionIcons";
import { EmailIcon } from "src/components/icons/MediaIcons";

export const getReplyToEmail = (keikkaData) => {
  if (keikkaData.auth.isPumppuAdmin && keikkaData.pumppuToimittaja)
    return keikkaData.pumppuToimittaja.asiakasContactPersonEmail;
  if (keikkaData.auth.isBetoniAdmin && keikkaData.betoniToimittaja)
    return keikkaData.betoniToimittaja.asiakasContactPersonEmail;
  if (keikkaData.auth.isLattiaAdmin && keikkaData.lattiaToimittaja)
    return keikkaData.lattiaToimittaja.asiakasContactPersonEmail;
  return keikkaData.keikkaContactPerson.personEmail;
};

export default function HandleSendTilaustiedotModal(props) {
  const emailToRef = useRef(null);
  const footerRef = useRef(null);
  const otsikkoRef = useRef("Tilausvahvistus");

  const [thisMail, setThisMail] = useState();
  const [snackbarIsOpen, setSnackbarIsOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const { user, token, socket } = useUserData();

  useEffect(() => {
    const _mc = new mailClass(props.keikkaData);
    setThisMail(_mc);
  }, [props.keikkaData.varmenne]);

  const otsikkoTxtForAdmin = "Betonin ja pumpun tilaustiedot";
  const otsikkoTxtForUserLuonnos = "Betonin ja pumpun tilaustiedot (luonnos)";
  const otsikkoTxtForUser = "Betonin ja pumpun tilaustiedot";
  const otsikkoTxt = props.keikkaData.auth.isKeikkaAdmin
    ? otsikkoTxtForAdmin
    : props.keikkaData.tila.keikkaTilaId < 3
    ? otsikkoTxtForUserLuonnos
    : otsikkoTxtForUser;

  const footerTxtForAdmin =
    "Tarkastathan tilauksesi tiedot ja otat yhteyttä mikäli huomaat virheitä tai sinulle herää kysyttävää. \n\n" +
    (thisMail && thisMail.pumppuToimittaja) +
    " " +
    (thisMail && thisMail.pumppuToimittajaPuh);
  let footerTxtForUser =
    "Mikäli sinulla on kysyttävää niin otathan yhteyttä. \n\n" +
    (thisMail && thisMail.pumppuToimittaja) +
    " " +
    (thisMail && thisMail.pumppuToimittajaPuh);
  const footerTxt = props.keikkaData.auth.isKeikkaAdmin ? footerTxtForAdmin : footerTxtForUser;

  const handleCancelKlik = async () => props.close();

  const handleSnackbarClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setSnackbarIsOpen(false);
  };
  const handleSnackbarOpen = (message) => {
    setSnackbarMessage(message);
    setSnackbarIsOpen(true);
  };

  const handleAcceptKlik = async () => {
    const personId = user.personId;

    thisMail.emailToEmail = emailToRef.current.value;
    thisMail.msgHeader = otsikkoRef.current.value;
    thisMail.emailHeader = otsikkoRef.current.value;
    thisMail.msgFooter = footerRef.current.value;
    sendTilaustiedot_exported(thisMail, props.keikkaData, personId, token, socket);
    handleSnackbarOpen("Sähköposti lähetetty");
    props.close();
  };
  const onKeyDown = (e) => {
    if (e.keyCode === 13) {
      e.preventDefault();
      handleAcceptKlik();
    }
  };
  return (
    <>
      <Portal>
        <Snackbar
          open={snackbarIsOpen}
          autoHideDuration={3000}
          onClose={handleSnackbarClose}
          anchorOrigin={{ vertical: "top", horizontal: "right" }}>
          <Alert onClose={handleSnackbarClose} severity="success">
            {snackbarMessage}
          </Alert>
        </Snackbar>
      </Portal>
      <Dialog
        open={props.open}
        onClose={props.close}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        fullWidth={true}
        maxWidth="sm">
        <DialogTitle id="alert-dialog-title">
          <div className="spaceBetween">
            <div style={{ display: "flex" }}>
              Lähetä sähköposti
              <HelperIcon helpId="sendTilaustiedotEmailButton" />
            </div>
            <IconButton onClick={handleCancelKlik} aria-label="Sulje">
              <CloseIcon color="primary" />
            </IconButton>
          </div>
        </DialogTitle>
        <Box
          component="form"
          sx={{
            "& > :not(style)": { m: 1 },
            paddingLeft: "20px",
            paddingRight: "20px",
            paddingBottom: "20px",
            width: "100%",
          }}
          noValidate>
          <Typography color="primary" variant="body2">
            Lähetä sähköposti.
            <br />
            Sähköposti pitää sisällään kaikki tilaustiedot{" "}
            {props.keikkaData.auth.isKeikkaAdmin &&
              "ja voit määritellä vastaanottajan, otsikon ja lopputekstin"}
            .
            <br />
          </Typography>
          <MyDivider />
          <TextField
            label="Vastaanottaja (email)"
            defaultValue={props.keikkaData.keikkaContactPerson.personEmail}
            fullWidth
            variant="standard"
            slotProps={{
              input: {
                startAdornment: (
                  <InputAdornment position="start">
                    <EmailIcon />
                  </InputAdornment>
                ),
              },
            }}
            inputRef={emailToRef}
            onKeyDown={onKeyDown}
          />
          <TextField
            label="Otsikko"
            defaultValue={otsikkoTxt}
            fullWidth
            variant="standard"
            inputRef={otsikkoRef}
            sx={{ display: props.keikkaData.auth.isKeikkaAdmin ? "" : "none" }}
          />
          <TextField
            label="Footer teksti, huomioita yms."
            defaultValue={footerTxt}
            fullWidth
            variant="standard"
            inputRef={footerRef}
            multiline
            sx={{ display: props.keikkaData.auth.isKeikkaAdmin ? "" : "none" }}
            noValidate
          />
          {false && props.keikkaData.auth.isKeikkaAdmin && (
            <>
              <Accordion>
                <AccordionSummary
                  expandIcon={<ExpandCollapseIcon />}
                  aria-controls="panel1a-content"
                  id="panel1a-header">
                  <Typography>Data</Typography>
                </AccordionSummary>
                <AccordionDetails>
                  <pre style={{ fontSize: "10px" }}>
                    {thisMail && JSON.stringify(thisMail, null, 2)}
                  </pre>
                </AccordionDetails>
              </Accordion>
            </>
          )}

          <StepButtons
            enableButtonAfterKlik
            onCancelKlik={() => handleCancelKlik()}
            onAcceptKlik={() => handleAcceptKlik()}
            rightButtonDisabled={false}
            rightButtonText="LÄHETÄ SÄHKÖPOSTI"
          />
        </Box>
      </Dialog>
    </>
  );
}

HandleSendTilaustiedotModal.propTypes = {
  keikkaData: PropTypes.object,
  open: PropTypes.bool,
  close: PropTypes.func,
};
